import React from 'react'
import { Link } from 'react-router'

import Icon from '@hixme-ui/icon'

import { HeaderCompanySelectorContainer } from 'components/HeaderCompanySelector/HeaderCompanySelectorContainer'

import { EnvironmentBarLabel, useShellClassName } from './environmentIndicator'
import classes from './Header.module.scss'

export const Header = () => {
  const shellClassName = useShellClassName()

  return (
    <div className={classes.root}>
      <div className={classes.separator} />
      <div className={`${classes.homeLink} ${classes.logoLink}`}>
        <Link to="/">
          <img
            alt="SureCo Enrollment Platform Home"
            className={classes.logo}
            src="/sureco_ep_logo.png"
          />
        </Link>
      </div>

      <div className={classes.separator} />

      <div className={shellClassName}>
        <div className={classes.bar}>
          <div className={classes.company}>
            <HeaderCompanySelectorContainer />
          </div>
          <div className={classes.actions}>
            <EnvironmentBarLabel />
            <Link to="/employees">
              <div className={classes.circleButton}>
                <Icon magnifyingGlass light />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
